import { render, staticRenderFns } from "./VoteCount.vue?vue&type=template&id=54edd2df&"
import script from "./VoteCount.vue?vue&type=script&lang=js&"
export * from "./VoteCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports